const _ = require('lodash');

module.exports = function (shopper, categoriesService, loginService, globalHeaderPanelService, breakpointsService, catalogService) {
    return {
        restrict: 'E',
        link(scope, elem) {

            scope.shopper = shopper;
            scope.selectedCategory = undefined;
            scope.loading = true;
            scope.loginService = loginService;
            scope.globalHeaderPanelService = globalHeaderPanelService;
            scope.stateOptions = {
                state: 'shop.browse.category.aisle',
                category: 'category',
                subCategory: 'aisle'
            };

            catalogService.getCategories({ Level: 0 }).then((categories) => {
               scope.categories = _.chain(categories)
                                       .filter('Attributes.display_order')
                                       .sortBy('Attributes.display_order')
                                       .value();
              scope.selectedCategory = scope.categories && scope.categories.length ? scope.categories[0] : {};
            });

            scope.selectCategory = function (category) {
               scope.selectedCategory = category;
            };

            scope.$on('headerPanel:open', () => {
                elem.find('.globalHeader-mobileNav').scrollTop(0);
            });

            scope.closeMenu = function () {
                globalHeaderPanelService.closePanel();
            };

            scope.logout = function () {
                loginService.logout();
            };

            scope.goToSignup = function () {
                globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.signup);
            };

            scope.getUrl = function (category, childCategory) {
                return scope.stateOptions.state + '({ ' + scope.stateOptions.category + ': "' + category.UrlFriendlyName + '", ' + scope.stateOptions.subCategory + ': "' + childCategory.UrlFriendlyName + '", name: undefined, productId: undefined, recipeId: undefined, cardId: undefined, pageNumber: undefined})';
            };

            scope.getDepartmentUrl = function (category) {
                return scope.stateOptions.state + '({ ' + scope.stateOptions.category + ': "' + category.UrlFriendlyName + '"})';
            };

            scope.openPanel = function (panel) {
                globalHeaderPanelService.openPanel(panel);
            };

            scope.isLoginPanelOpen = function () {
                return breakpointsService.isSmallFormat && globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.login);
            };

            scope.isNavMenuPanelOpen = function () {
                return breakpointsService.isSmallFormat && globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.browse);
            };

            scope.isRegisterOpen = function () {
                return globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.signup);
            };

            scope.isPasswordResetOpen = function () {
                return globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.resetpassword);
            };

            scope.isSmallFormat = breakpointsService.isSmallFormat();
        },
        template: require('./hamburger-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/hamburger-directive.js
 **/